import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { FileText, Download, CheckCircle } from 'lucide-react';
import api from '../utils/api';
import { toast } from 'sonner';

export default function Documents() {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/documents').then(res => setDocuments(res.data)).finally(() => setLoading(false));
  }, []);

  const approveDocument = async (id) => {
    try {
      await api.put(`/documents/${id}/approve`);
      toast.success('Document approved');
      const res = await api.get('/documents');
      setDocuments(res.data);
    } catch (error) {
      toast.error('Failed to approve document');
    }
  };

  if (loading) return <div className="flex items-center justify-center h-96"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div></div>;

  return (
    <div className="space-y-6" data-testid="documents-page">
      <div><h1 className="text-4xl font-bold text-gray-900">Documents</h1><p className="text-gray-600">GMP-compliant document management with version control</p></div>
      
      <Card>
        <CardHeader><CardTitle>Document Library</CardTitle></CardHeader>
        <CardContent>
          <div className="space-y-3">
            {documents.map(doc => (
              <Card key={doc.id} className="card-hover" data-testid={`doc-${doc.id}`}>
                <CardContent className="p-4">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center"><FileText className="w-5 h-5 text-blue-600" /></div>
                      <div>
                        <h3 className="font-semibold">{doc.title}</h3>
                        <p className="text-sm text-gray-600">Version {doc.version} • {doc.category}</p>
                        <span className={`text-xs px-2 py-1 rounded ${doc.status === 'approved' ? 'bg-green-100 text-green-700' : doc.status === 'review' ? 'bg-yellow-100 text-yellow-700' : 'bg-gray-100 text-gray-700'}`}>{doc.status}</span>
                      </div>
                    </div>
                    <div className="flex space-x-2">
                      {doc.status !== 'approved' && <Button size="sm" onClick={() => approveDocument(doc.id)} data-testid={`approve-${doc.id}`}><CheckCircle className="w-4 h-4 mr-1" />Approve</Button>}
                      <Button size="sm" variant="outline"><Download className="w-4 h-4" /></Button>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
            {documents.length === 0 && <p className="text-center py-12 text-gray-500">No documents found</p>}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
